{{!-- if singleRegionID is set, this div acts as marionette-region and the rest of this template is ignored--}}
<div {{#if singleRegionID}} id="{{singleRegionID}}" {{/if}} class="modal-body">
	<div class="panel-group" id="accordion">
		{{#each writeModes}}
			<div class="panel panel-default" style="position: relative;">
				<div class="panel-heading">
					<h4 class="panel-title">
						<a id="{{id}}" class="js-toggleMode" href="#collapse{{@index}}"
							data-toggle="collapse" data-parent="#accordion">
							{{#if icon}}<i class="{{icon}}"></i> {{/if}}{{title}}
						</a>
					</h4>
				</div>
				<div id="collapse{{@index}}" class="panel-collapse collapse{{#if active}} in{{/if}}">
					<div class="wizard panel-body">
						{{#if template}}
							{{> (lookup . 'template') ../this}}
						{{else}}
							<div id="{{region}}"></div>
						{{/if}}
					</div>
				</div>
			</div>
		{{/each}}
	</div>
</div>
